var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",style:('background-color: #f4f4f4')},[_c('div',{staticClass:"logo position-relative"},[_c('SystemSelect',{staticClass:"logix",staticStyle:{"max-width":"200px"},attrs:{"base-url":_vm.authUrl,"hub-url":_vm.hubUrl,"current":_vm.system,"token":_vm.oidcAccessToken}}),_c('RightMenu',{staticClass:"right-menu"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }